"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLink = exports.UserIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));
var _coreInteraction = _interopRequireDefault(require("@vfuk/core-interaction"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var UserIcon = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "UserIconstyle__UserIcon",
  componentId: "sc-1xxg7p8-0"
})(function () {
  return [];
});
exports.UserIcon = UserIcon;
var UserLink = (0, _styledComponents["default"])(_coreInteraction["default"]).withConfig({
  displayName: "UserIconstyle__UserLink",
  componentId: "sc-1xxg7p8-1"
})(function () {
  return [];
});
exports.UserLink = UserLink;